import {Inject, Injectable} from '@angular/core';
import {select, Store} from "@ngrx/store";
import {Observable} from "rxjs";
import {
  FulfillmentActions,
  FulfillmentAPiActions,
  FulfillmentChannelActions
} from "../state/fulfillment/fulfillment.action";
import {fulfillmentFeature} from "../state/fulfillment/fulfillment.state";
import {FulfillmentFilterPayloadModel} from "../../models/fulfillment-filter-payload.model";
import {PaginationModel} from "../../../commons/angular/models/pagination.model";
import {FulfillmentModel} from "../../models/fulfillment.model";

@Injectable()
export class FulfillmentFacadeService {

  constructor(@Inject(Store) private store: Store<FulfillmentModel>) {
  }

  subscribeToChannels() {
    this.store.dispatch(FulfillmentChannelActions.subscribe());
  }

  unsubscribeFromChannels() {
    this.store.dispatch(FulfillmentChannelActions.unsubscribe());
  }

  removeAll() {
    this.store.dispatch(FulfillmentActions.removeAll());
  }

  getPaginatedResult(page: number, size: number, payload: FulfillmentFilterPayloadModel) {
    this.store.dispatch(FulfillmentAPiActions.getFulfillmentsPaginatedResult({page, size, payload}));
  }

  getOne(fulfillmentId: string, expand?: boolean) {
    this.store.dispatch(FulfillmentAPiActions.getFulfillment({fulfillmentId, expand}));
  }

  selectOne(fulfillmentId: string): Observable<FulfillmentModel> {
    return this.store.select(fulfillmentFeature.selectFulfillment(fulfillmentId))
  }

  selectAll(): Observable<FulfillmentModel[]> {
    return this.store.select(fulfillmentFeature.selectAll);
  }

  selectPaginatedResults(): Observable<{ pagination: PaginationModel, fulfillments: FulfillmentModel[] }> {
    return this.store.select(fulfillmentFeature.selectPaginatedResult());
  }

  selectIsLoading(): Observable<boolean> {
    return this.store.select(fulfillmentFeature.selectIsLoading());
  }

  selectInitialized(): Observable<boolean> {
    return this.store.select(fulfillmentFeature.selectInitialized());
  }

}
